import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataDeleteRoutesDtoModelBase } from './PlanningActionMetadataDeleteRoutesDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataDeleteRoutesDtoModel */
export interface PlanningActionMetadataDeleteRoutesDtoModelType extends Instance<typeof PlanningActionMetadataDeleteRoutesDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataDeleteRoutesDtoModel */
export {
  selectFromPlanningActionMetadataDeleteRoutesDto, planningActionMetadataDeleteRoutesDtoModelPrimitives, PlanningActionMetadataDeleteRoutesDtoModelSelector,
} from './PlanningActionMetadataDeleteRoutesDtoModel.base';

/**
 * PlanningActionMetadataDeleteRoutesDtoModel
 */
export const PlanningActionMetadataDeleteRoutesDtoModel = PlanningActionMetadataDeleteRoutesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
